import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
import styles from './BeforeAfter.module.css';

const ROWS = [
    ['Dues and advances written in a notebook', 'Digital khata with a running ledger for every client'],
    ['Commission arguments at month end', 'Clear credit for the seller and the stylist on every bill'],
    ['Clients forget their appointment', 'WhatsApp confirmation and reminder in one tap'],
    ['Package visits tracked from memory', 'Every visit recorded, with services left'],
    ['A weekend spent adding GST totals', 'CA-ready GST report in one click'],
    ['Lost clients stay lost', 'A WhatsApp offer to everyone who has not visited in 60 days'],
];

export default function BeforeAfter() {
    const [withHirsta, setWithHirsta] = useState(true);
    return (
        <div className={styles.wrap}>
            <div className={styles.switch} role="tablist" aria-label="Compare">
                <button type="button" role="tab" aria-selected={!withHirsta} onClick={() => setWithHirsta(false)} className={!withHirsta ? styles.on : ''}>
                    {!withHirsta && <motion.span layoutId="ba-pill" className={styles.pill} />}
                    <span className={styles.label}>Without Hirsta</span>
                </button>
                <button type="button" role="tab" aria-selected={withHirsta} onClick={() => setWithHirsta(true)} className={withHirsta ? styles.on : ''}>
                    {withHirsta && <motion.span layoutId="ba-pill" className={`${styles.pill} ${styles.pillOn}`} />}
                    <span className={styles.label}>With Hirsta</span>
                </button>
            </div>

            <ul className={`${styles.list} ${withHirsta ? styles.listOn : ''}`}>
                {ROWS.map((r, i) => (
                    <li key={r[0]}>
                        <AnimatePresence mode="wait" initial={false}>
                            <motion.div
                                key={withHirsta ? 'a' : 'b'}
                                className={styles.row}
                                initial={{ opacity: 0, y: 8 }}
                                animate={{ opacity: 1, y: 0, transition: { delay: i * 0.04, duration: 0.25 } }}
                                exit={{ opacity: 0, y: -8, transition: { duration: 0.12 } }}
                            >
                                {withHirsta ? <CheckCircle2 size={18} className={styles.yes} /> : <XCircle size={18} className={styles.no} />}
                                <span>{withHirsta ? r[1] : r[0]}</span>
                            </motion.div>
                        </AnimatePresence>
                    </li>
                ))}
            </ul>
        </div>
    );
}
